import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgIf } from '@angular/common';

export interface LegalDocument {
  title: string;
  content: string;
}

export interface LegalDocumentsConfig {
  imprint?: { content: string; title?: string };
  terms?: { content: string; title?: string };
  privacy?: { content: string; title?: string };
}

@Component({
  selector: 'app-legal-documents',
  templateUrl: './legal-documents.component.html',
  styleUrls: ['./legal-documents.component.scss'],
  standalone: true,
  imports: [
    NgIf
  ],
})
export class LegalDocumentsComponent implements OnInit {
  @Input() legalDocuments?: LegalDocumentsConfig;

  isModalOpen = false;
  currentDocument?: LegalDocument;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    // Legal documents are passed via input, no need to fetch separately
  }

  hasLegalDocuments(): boolean {
    return !!(
      this.legalDocuments?.imprint?.content ||
      this.legalDocuments?.terms?.content ||
      this.legalDocuments?.privacy?.content
    );
  }

  openModal(documentType: 'imprint' | 'terms' | 'privacy', event: Event) {
    event.preventDefault();

    const document = this.legalDocuments?.[documentType];
    if (document?.content) {
      this.currentDocument = {
        title: document.title || this.getDefaultTitle(documentType),
        content: document.content
      };
      this.isModalOpen = true;
    }
  }

  closeModal() {
    this.isModalOpen = false;
    this.currentDocument = undefined;
  }

  private getDefaultTitle(documentType: string): string {
    switch (documentType) {
      case 'imprint': return 'Imprint';
      case 'terms': return 'Terms of Service';
      case 'privacy': return 'Privacy Policy';
      default: return documentType.charAt(0).toUpperCase() + documentType.slice(1);
    }
  }
}
